import request from '@/utils/changanRequest'
// 查询预约场所详细
export function getInfo(id) {
  return request({
    url: '/system/appointmentInfo/' + id,
    method: 'get'
  })
}
export function getCountByHour(params) {
  return request({
    url: '/system/appointmentInfo/getCountByHour',
    method: 'get',
    params: params
  })
}
// export function appointmentRecord(params) {
//   return request({
//     url: '/system/appointmentRecord',
//     method: 'post',
//     data: params
//   })
// }
export function appointmentRecord(params) {
  return request({
    url: '/system/appointmentRecord/appletSave',
    method: 'post',
    data: params
  })
}
